var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("header", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("portal-target", {
              staticClass: "d-flex align-items-center mt-1",
              attrs: { name: "sidebar-toggle" }
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle.sidebar-fields",
                    modifiers: { "sidebar-fields": true }
                  }
                ],
                staticClass: "custom-btn-secondary mr-1",
                attrs: { id: "table-settings" }
              },
              [_c("v-icon", { attrs: { name: "buttons/cog", size: 13 } })],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "table-settings",
                  triggers: "hover",
                  "custom-class": "custom-tooltip",
                  noninteractive: ""
                }
              },
              [_vm._v("\n        Колонки\n      ")]
            ),
            _vm._v(" "),
            _vm.canEditLocationVacancies()
              ? _c(
                  "b-btn",
                  {
                    staticClass: "custom-btn-primary",
                    attrs: { disabled: _vm.isBusy },
                    on: {
                      click: function($event) {
                        return _vm.showModal(null, false)
                      }
                    }
                  },
                  [
                    _vm.isBusy
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                    _vm._v("\n        Новый шаблон\n      ")
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-body" }, [
        _c(
          "div",
          { staticClass: "page-filters" },
          [
            _c(
              "filters-drawer",
              {
                attrs: {
                  query: _vm.filters.query,
                  "is-busy": _vm.isBusy,
                  "filter-tags": _vm.activeFilterTags
                },
                on: {
                  "update:query": function($event) {
                    return _vm.$set(_vm.filters, "query", $event)
                  },
                  "remove-tag": _vm.removeFilterTag,
                  submit: _vm.onSearch,
                  clear: _vm.onClearFilters
                }
              },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("label", { staticClass: "small text-muted" }, [
                      _vm._v("Шаблоны вакансий")
                    ]),
                    _vm._v(" "),
                    _c("vacancy-multi-select", {
                      ref: "vacancy_multi_select",
                      staticClass: "mb-1",
                      attrs: { id: "vacancy_multi_select" },
                      on: { onSelect: _vm.onSelectVacancy }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "mt-1", attrs: { cols: "12" } },
                  [
                    _c("label", { staticClass: "small text-muted" }, [
                      _vm._v("Объекты")
                    ]),
                    _vm._v(" "),
                    _c("location-multi-select", {
                      ref: "location_multi_select",
                      attrs: { id: "location-multi-select" },
                      on: { onSelect: _vm.onSelectLocation }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-table-container" },
          [
            _c("b-table", {
              ref: "recruit_location_vacancies",
              staticClass: "custom-table mb-0 text-small",
              attrs: {
                id: "recruit-location-vacancies",
                "sticky-header": "",
                selectable: "",
                "select-mode": "single",
                responsive: "",
                "show-empty": "",
                "empty-text": _vm.$t("message.common.emptyTable"),
                busy: _vm.isBusy,
                items: _vm.items,
                fields: _vm.renderedFields,
                "no-provider-filtering": "",
                "no-provider-paging": "",
                "no-provider-sorting": "",
                "no-local-sorting": ""
              },
              on: {
                "update:busy": function($event) {
                  _vm.isBusy = $event
                },
                "sort-changed": _vm.sortChanged,
                "row-dblclicked": _vm.onRowDblClicked
              },
              scopedSlots: _vm._u([
                {
                  key: "table-busy",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "text-center text-success my-2" },
                        [
                          _c("b-spinner", { staticClass: "align-middle" }),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Загрузка")])
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "cell(action)",
                  fn: function(row) {
                    return [
                      _c(
                        "b-dropdown",
                        {
                          attrs: {
                            size: "sm",
                            variant: "link",
                            "toggle-class": "text-decoration-none p-0",
                            "no-caret": ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button-content",
                                fn: function() {
                                  return [
                                    _c("v-icon", {
                                      attrs: {
                                        name: "buttons/ellipsis_vertical",
                                        size: 15
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(" "),
                          _vm.canEditLocationVacancies()
                            ? _c(
                                "b-dropdown-item-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showModal(row.item.id, false)
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "edit" }
                                  }),
                                  _vm._v(
                                    "\n              Редактировать\n            "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item-button",
                            {
                              attrs: { variant: "success" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showModal(row.item.id, true)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "eye" }
                              }),
                              _vm._v("\n              Смотреть\n            ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.canEditLocationVacancies()
                            ? _c(
                                "b-dropdown-item-button",
                                {
                                  attrs: { variant: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onRemove(row)
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "trash" }
                                  }),
                                  _vm._v(
                                    "\n              Удалить\n            "
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-pagination" },
          [
            _c("pagination-footer", {
              attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
              on: {
                "update:perPage": function($event) {
                  _vm.perPage = $event
                },
                "update:per-page": function($event) {
                  _vm.perPage = $event
                },
                "page-click": _vm.onPagination,
                "per-page-change": _vm.onPerPageChange
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("DynamicTables", {
        attrs: {
          "storage-key": "recruitLocationVacancies_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      }),
      _vm._v(" "),
      _c("RecruitLocationVacancy", {
        ref: "recruit_location_vacancy",
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bdf2701e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdf2701e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/RecruitLocationVacancies.vue
// module id = null
// module chunks = 